import moment from "moment";
import { IProductRow } from "models/table";

export default function TimeTableCell({ orderReadyTime }: IProductRow) {
  return moment(orderReadyTime).format("HH:mm");
}
